export default __webpack_public_path__ + "resources/images/ic-clock.png";